import { crystals, crystalTypes } from '../../core/gameConstants';

export class CrystalPerTypeHelper {
  constructor() {
    this.reset();
  }

  get crystals() {
    return Object.entries(this.crystalPerType)
      .reduce((acc, [key, indexes]) => {
        indexes.forEach(index => {
          acc[index] = Number(key);
        });
        return acc;
      }, []);
  }

  reset() {
    this.crystalPerType = crystals.reduce((acc, item, index) => {
      acc[item].push(index);
      return acc;
    }, {
      [crystalTypes.crystal_blue]: [],
      [crystalTypes.crystal_green]: [],
      [crystalTypes.crystal_yellow]: [],
      [crystalTypes.crystal_magenta]: [],
      [crystalTypes.crystal_gold]: [],
    });
  }

  get nativeCrystals() {
    return crystals;
  }
}

export const crystalPerTypeHelper = new CrystalPerTypeHelper();
window.crystalPerTypeHelper = crystalPerTypeHelper;
